import { RichTextContent } from "../ui/RichTextContent";

type KycAdminCommentsProps = {
  value?: string | null;
  format?: string | null;
};

function normalizeLegacyComment(value: string) {
  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/\/n /gi, "\n")
    .replace(/\\n/g, "\n")
    .replace(/\r\n?/g, "\n");
}

export function KycAdminComments({
  value,
  format,
}: KycAdminCommentsProps): JSX.Element {
  const normalizedFormat = format === "html" ? "html" : "plain";

  return (
    <RichTextContent
      value={
        normalizedFormat === "html"
          ? value
          : normalizeLegacyComment(value ?? "")
      }
      format={normalizedFormat}
    />
  );
}
